import React from 'react';

export default function AdminPersonnelPageHeader({ badge, title, description, actions }) {
  return (
    <header className="ap-page-header ap-no-print mb-4">
      <div className="ap-page-header__main">
        <div className="ap-page-header__text">
          {badge && <span className="ap-page-header__badge">{badge}</span>}
          <h1 className="ap-page-title mb-1">{title}</h1>
          {description && <p className="ap-page-header__desc mb-0">{description}</p>}
        </div>
        {actions ? <div className="ap-page-header__actions">{actions}</div> : null}
      </div>
    </header>
  );
}
